import { render, staticRenderFns } from "./databaseList.vue?vue&type=template&id=54f94d63&"
import script from "./databaseList.vue?vue&type=script&lang=js&"
export * from "./databaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports